export default "__VITE_ASSET__b608d443__"